import React, { useEffect, useRef } from 'react'
import styles from './StepContainer.module.css'
import { StepWrapperProps } from './types'
import { TRANSLATION_PERCENTAGE } from '../../../../constants/progressBanner'

export const StepWrapper = ({ currentStep, children }: StepWrapperProps) => {
    const containerRef = useRef<HTMLDivElement>(null)
    const wrapperRef = useRef<HTMLDivElement>(null)

    useEffect(() => {
        if (!containerRef.current || !wrapperRef.current) return
        const currentStepEl = wrapperRef.current.children[currentStep] as HTMLElement
        if (!currentStepEl) return

        const updateHeight = () => {
            const height = currentStepEl.offsetHeight
            if (containerRef.current && height > 0) {
                containerRef.current.style.height = `${height}px`
            }
        }

        updateHeight()

        if (typeof ResizeObserver !== 'undefined') {
            const resizeObserver = new ResizeObserver(updateHeight)
            resizeObserver.observe(currentStepEl)
            return () => resizeObserver.disconnect()
        }
    }, [currentStep])

    return (
        <div className={styles.formContainer} ref={containerRef}>
            <div
                className={styles.formWrapper}
                ref={wrapperRef}
                style={{
                    transform: `translateX(-${currentStep * TRANSLATION_PERCENTAGE}%)`,
                }}
            >
                {children}
            </div>
        </div>
    )
}
